import { type RegistrarFormSchema } from './schemas';

export const defaultValues: RegistrarFormSchema = {
  id: -1,
  name: '',
  url: '',
  notes: '',
  logo: undefined,
  phone_numbers: [],
  domains: [],
} as const;
